module.exports = __webpack_public_path__ + "static/mainlogo--white-5aa0da4077ec7dfae897db655c4e3fd9.svg";